import Button from "../../components/Button";

function FeaturesIllustrated() {
    const features: featureObject[] = [
        {
            title: "Dashboard",
            subtitle: "Important metrics at a glance.",
            bulletPoints: [
                "Portfolio Allocation",
                "Portfolio Performance",
                "Selected Key Indicators",
                "Latest transactions fiat & crypto",
                "Unclaimed Rewards",
                "Personal Risk Indicator"
            ],
            image: "/DEMO/illustrations/dashboard.png"
        },
        {
            title: "Transaction Book",
            subtitle: "Track your crypto and fiat transactions.",
            bulletPoints: [
                "Automated capture supported for a growing number of blockchains",
                "Manual recording and editing of transactions",
                "Link fiat & crypto transactions",
                "CSV Export for accounting & tax reporting",
                "Visualisation of transactions as graph (Coming 2023)",
                "Open Banking Integration (Coming 2023)"
            ],
            image: "/DEMO/illustrations/risklevel.png"
        },
        {
            title: "Portfolio Analytics",
            subtitle: "Monitor performance of your portfolio and investments.",
            bulletPoints: [
                "Net asset value calculation at lowest asset level",
                "Support for manuel managed assets and equity positions",
                "Staking and liquidity mining integration",
                "Automated asset pricing by consenus algorithmus",
                "Alerts if the portfolio breaches a defined rule.",
                "ROI calulcation at asset level (Coming 2023)",
                "Cashflow analytics (Coming 2023)",
                "Visualisation as graph (Coming 2023)"
            ],
            image: "/DEMO/illustrations/sharemanager.png"
        },
        {
            title: "Asset Price Manager",
            subtitle: "Modules to tailor specific needs",
            bulletPoints: [
                "Automated price list of day by consensus",
                "Possibility to manage asset price yourself for unlisted assets.",
                "Possibility to change and confirme asset prices",
                "Automated Workflow & Notficiations",
                "Price Change Log",
                "CSV. data export",
                "Integration of New Price Providers (Coming 2023)",
            ],
            image: "/DEMO/illustrations/sharemanager.png"
        },
        {
            title: "Crypto Fund Modul",
            subtitle: "Modules to tailor specific needs",
            bulletPoints: [
                "Investor & Share Management",
                "Integration of individual fund calculation models",
                "Daily calculation of fund net asset value & virtuel share price",
                "Automated management & performance fee accounting",
                "CSV. data export for accounting and tax reporting",
                "Private API (Coming 2023)",
                "Specific Cashflow Reports (Coming 2023)",
                "Support for tokinized funds(Coming 2023)",
            ],
            image: "/DEMO/illustrations/sharemanager.png"
        }
    ];
    return(
        <div className="max-w-screen-xl box m-auto mb-32 max-xl:p-5" id="features">
            <h1 className="text-4xl font-bold text-slate-800 mb-3 max-md:text-3xl">
            Our purpose is to reduce as many sources of failer <br/>through reducing administrative efforts by intelligent workflows!
            </h1>
            <p className="font-medium text-slate-400 mb-10">
            The administrative burden can quickly make investments unattractive. Our goal is to use automation and standardization<br/>to give our clients the possibility to invest also in young projects and eco systems without exploding efforts in tracking and reporting.
            </p>
            <div className="flex justify-items-stretch flex-wrap">
                {
                    features.map((feature, i) => (
                        <div className={"flex flex-row basis-full flex-wrap  mb-10 max-sm:mb-15 " + (i%2 && " flex-row-reverse")} key={"feature-" + i}>
                            <img src={feature.image} alt="feature" className="w-1/2  max-sm:w-full max-sm:mx-auto object-contain" />
                            <div className={"box my-auto w-1/2 max-sm:w-full max-sm:mx-auto " + (i%2 ? "sm:pr-10" : "sm:pl-10")}>
                                <p className="text-blue-600 text-left max-md:mt-4 max-md:text-sm">
                                    {feature.subtitle}
                                </p>
                                <h1 className="font-bold text-slate-800 text-3xl text-left mb-2 max-md:text-2xl">
                                    {feature.title}
                                </h1>
                                {feature.bulletPoints.map((bulletPoint: string, i) => (
                                    <div className="flex" key={"bulletPoint-" + i}>
                                        <i className="iconoir-check text-blue-600 mr-2 pt-1 text-xl"></i>
                                        <p className="text-slate-400 text-left" key={"bulletPoint-" + i}>
                                            {bulletPoint}
                                        </p>
                                    </div>
                                ))}
                            </div>
                        </div>
                    ))
                }
            </div>
            <Button text="See more" color="secondary" size="large" />
        </div>
    );
}

export default FeaturesIllustrated;

interface featureObject {
    title: string;
    subtitle: string;
    bulletPoints: string[];
    image: string;
}